<template>
  <a :href="'//' + cms.footerQuestion" class="contact-button" target="_blank">
    <img src="images/chat-green.svg" />
  </a>
</template>

<script>
export default {
  data() {
    return {
      /* eslint-disable */
      cms: {
        footerQuestion: FOOTER_QUESTION
      }
      /* eslint-enable */
    };
  }
};
</script>

<style>
.contact-button {
  position: absolute;
  bottom: 20px;
  right: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #f6f6f6;
   border: solid 4px #d8d8d8;
}

.contact-button img {
  margin-top: 16px;
  margin-left: 15px;
  display: block;
  transition: transform ease 0.25s;
}

.contact-button:hover img {
  transform: scale(1.2);
}

@media (max-width: 1023px) {
  .contact-button {
    bottom: 15px;
    right: 10px;
  }
}
</style>
